<template>
  <div class="clients-range-slider">
    <div class="clients-chart">
      <div
        v-for="(item, index) in filteredDistribution"
        :key="item.color"
        :class="{ 'first-chart': index === 0, 'last-chart': index === filteredDistribution.length - 1 }"
        :style="`width: ${item.value}%; height: 12px; background: ${item.color}`"
      >
        <mf-tooltip top>
          <template #activator="{ on }">
            <div class="item-tooltip" :style="`width: 100%; height: 12px`"></div>
          </template>
          <span class="text-cinza-d10">{{ localeString(item.value, 0) }}% {{ item.label }}</span>
        </mf-tooltip>
      </div>
    </div>

    <div class="legend-content">
      <div v-for="item in filteredDistribution" :key="item.color" class="legend-item">
        <mf-tooltip bottom>
          <template #activator="{ on }">
            <div class="d-flex flex-row align-center" style="gap: 4px">
              <div class="item-square" :style="`background-color: ${item.color}`" />
              <span class="item-percentage" :style="{ color: item.color }">{{ localeString(item.value, 0) }}%</span>
            </div>
          </template>
          <span>{{ item.label }}</span>
        </mf-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ClientsDistributionBar',
  props: {
    clientsDistribution: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    distribution() {
      const { actives, at_risk, losses, never_bought, recent_inactives } = this.clientsDistribution
      return [
        {
          label: 'Ativos',
          color: '#0FC94D',
          value: actives * 100,
        },
        {
          label: 'Inativos recentes',
          color: '#F3AF00',
          value: recent_inactives * 100,
        },
        {
          label: 'Risco de perder',
          color: '#F36600',
          value: at_risk * 100,
        },
        {
          label: 'Perdidos',
          color: '#B3280D',
          value: losses * 100,
        },
        {
          label: 'Nunca compraram',
          color: '#969EA7',
          value: never_bought * 100,
        },
      ]
    },
    filteredDistribution() {
      return this.distribution.filter((item) => item.value > 0)
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss">
.clients-range-slider {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .text-cinza-d10 {
    color: $cinza-d10;
  }

  .text-cinza-l10 {
    color: $cinza-l10;
  }

  .clients-chart {
    height: 12px;
    width: 100%;
    display: inline-flex;

    .first-chart {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    .last-chart {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }

  .item-tooltip:hover {
    opacity: 0.2;
    background-color: white;
  }

  .legend-content {
    display: flex;
    align-items: center;
    gap: 48px;
    flex-wrap: wrap;
    font-size: 14px;

    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;

      .item-square {
        width: 12px;
        height: 12px;
        border-radius: 4px;
      }

      .item-percentage {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
}
</style>
